module.exports = __webpack_public_path__ + "static/media/sort-numeric-up-alt.a994ad38.svg";